import { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import "./Shortlisted.css";
import SSMM1 from "../img/kavitha.png";
import SSMM2 from "../img/sheray.png";
import SSMM3 from "../img/farhan.png";
import SSMM4 from "../img/arun.png";
import userAvatar from "../img/user-avatar.png";
import { fetchUserShortlists, fetchUserShortlistsMine, fetchUserShortlistsReceived } from "../redux/shortListSlice"
import { useDispatch, useSelector } from "react-redux";
import { sendInterestToProfile, userAddShortlistProfile } from "../redux/matchFilterSlice";
import { useTranslation } from "react-i18next";
const profiles = [
  {
    id: 1,
    name: "Kavitha Ramesh",
    age: 27,
    location: "Chennai, TN",
    education: "MBA",
    profession: "Senior Marketing Manager",
    bio: "Family-oriented, loves classical dance and travel. Seeks a partner who values traditions.",
    match: 97,
    verified: true,
    img: SSMM1,
  },
  {
    id: 2,
    name: "Divya Suresh",
    age: 26,
    location: "Coimbatore, TN",
    education: "B.Tech",
    profession: "Software Engineer at TCS",
    bio: "Passionate about technology and cooking. Looking for a caring, ambitious life partner to...",
    match: 95,
    verified: true,
    img: SSMM2,
  },
  {
    id: 3,
    name: "Priya Murugan",
    age: 28,
    location: "Madurai, TN",
    education: "MBBS",
    profession: "Doctor at Apollo",
    bio: "Dedicated doctor with a heart for service. Values a partner with integrity, warmth, and...",
    match: 93,
    verified: true,
    img: SSMM3,
  },
  {
    id: 4,
    name: "Ananya Kumar",
    age: 25,
    location: "Bangalore, KA",
    education: "M.Sc",
    profession: "Data Scientist at Infosys",
    bio: "Data enthusiast and weekend trekker. Believes in mutual respect and building a partnership...",
    match: 91,
    verified: true,
    img: SSMM4,
  },
  {
    id: 5,
    name: "Meena Venkatesh",
    age: 29,
    location: "Salem, TN",
    education: "M.Com",
    profession: "Chartered Accountant",
    bio: "Pragmatic and warm-hearted. Enjoys Carnatic music, cooking for loved ones, and weekend...",
    match: 89,
    verified: true,
    img: SSMM1,
  },
  {
    id: 6,
    name: "Lakshmi Thirumal",
    age: 27,
    location: "Trichy, TN",
    education: "B.Arch",
    profession: "Architect at L&T",
    bio: "Creative soul who designs beautiful spaces by day and writes poetry by night. Values...",
    match: 87,
    verified: true,
    img: SSMM2,
  },
];

const mutualProfile = {
  name: "Ravi Kumar",
  age: 29,
  location: "Delhi, NCR",
  profession: "Architect",
  match: 92,
};

/* ─────────────────────────────────────────
   CHATBOX COMPONENT
───────────────────────────────────────── */
function ChatBox({ isOpen, onClose, profile }) {
  const [messages, setMessages] = useState([
    { id: 1, from: "them", text: "Hey there!", time: "10:32 AM" },
    { id: 2, from: "me", text: "Hi! How are you?", time: "10:33 AM" },
  ]);
  const [inputValue, setInputValue] = useState("");
  const [visible, setVisible] = useState(false);
  const [animateIn, setAnimateIn] = useState(false);
  const messagesEndRef = useRef(null);
  const inputRef = useRef(null);

  useEffect(() => {
    if (isOpen) {
      setVisible(true);
      requestAnimationFrame(() => {
        requestAnimationFrame(() => setAnimateIn(true));
      });
      setTimeout(() => inputRef.current?.focus(), 350);
    } else {
      setAnimateIn(false);
      const t = setTimeout(() => setVisible(false), 350);
      return () => clearTimeout(t);
    }
  }, [isOpen]);

  useEffect(() => {
    messagesEndRef.current?.scrollIntoView({ behavior: "smooth" });
  }, [messages]);

  const handleSend = () => {
    const text = inputValue.trim();
    if (!text) return;
    const now = new Date();
    const time = now.toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" });
    setMessages((prev) => [...prev, { id: Date.now(), from: "me", text, time }]);
    setInputValue("");
    // TODO: plug in your backend API here
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter" && !e.shiftKey) {
      e.preventDefault();
      handleSend();
    }
  };

  if (!visible) return null;

  const name = profile?.name || "Ravi Kumar";
  const avatar = profile?.img || null;

  return (
    <div className={`cb-overlay ${animateIn ? "cb-overlay--in" : ""}`} onClick={onClose}>
      <div
        className={`cb-box ${animateIn ? "cb-box--in" : ""}`}
        onClick={(e) => e.stopPropagation()}
      >
        {/* Header */}
        <div className="cb-header">
          <div className="cb-header-left">
            <div className="cb-avatar">
              {avatar ? (
                <img src={avatar} alt={name} />
              ) : (
                <svg viewBox="0 0 24 24" fill="rgba(255,255,255,0.7)" width="28" height="28">
                  <path d="M12 12c2.7 0 4.8-2.1 4.8-4.8S14.7 2.4 12 2.4 7.2 4.5 7.2 7.2 9.3 12 12 12zm0 2.4c-3.2 0-9.6 1.6-9.6 4.8v2.4h19.2v-2.4c0-3.2-6.4-4.8-9.6-4.8z" />
                </svg>
              )}
              <span className="cb-online-dot" />
            </div>
            <div className="cb-header-info">
              <span className="cb-header-name">{name}</span>
              <span className="cb-active-now">
                <span className="cb-active-dot" />
                Active now
              </span>
            </div>
          </div>
          <button className="cb-close-btn" onClick={onClose} aria-label="Close chat">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
              <line x1="18" y1="6" x2="6" y2="18" />
              <line x1="6" y1="6" x2="18" y2="18" />
            </svg>
          </button>
        </div>

        {/* Messages */}
        <div className="cb-messages">
          {messages.map((msg, i) => (
            <div
              key={msg.id}
              className={`cb-msg-row cb-msg-row--${msg.from}`}
              style={{ animationDelay: `${i * 0.04}s` }}
            >
              <div className={`cb-bubble cb-bubble--${msg.from}`}>
                <span className="cb-bubble-text">{msg.text}</span>
                <span className="cb-bubble-time">{msg.time}</span>
              </div>
            </div>
          ))}
          <div ref={messagesEndRef} />
        </div>

        {/* Input */}
        <div className="cb-input-row">
          <input
            ref={inputRef}
            className="cb-input"
            type="text"
            placeholder="Type a message..."
            value={inputValue}
            onChange={(e) => setInputValue(e.target.value)}
            onKeyDown={handleKeyDown}
          />
          <button
            className={`cb-send-btn ${inputValue.trim() ? "cb-send-btn--active" : ""}`}
            onClick={handleSend}
            aria-label="Send message"
          >
            Send
          </button>
        </div>
      </div>
    </div>
  );
}

/* ─────────────────────────────────────────
   MUTUAL BANNER
───────────────────────────────────────── */
function MutualBanner({ onStartConvo }) {
  return (
    <>
      <p className="sl-mutual-label">Mutual Interest</p>
      <div className="sl-mutual-card">
        <div className="sl-mutual-avatar">
          <svg
            viewBox="0 0 24 24"
            fill="rgba(255,255,255,0.6)"
            width="32"
            height="32"
          >
            <path d="M12 12c2.7 0 4.8-2.1 4.8-4.8S14.7 2.4 12 2.4 7.2 4.5 7.2 7.2 9.3 12 12 12zm0 2.4c-3.2 0-9.6 1.6-9.6 4.8v2.4h19.2v-2.4c0-3.2-6.4-4.8-9.6-4.8z" />
          </svg>
        </div>
        <div className="sl-mutual-info">
          <div className="sl-mutual-badge">
            <span className="sl-heart-pulse">♥</span>
            YOU BOTH SHOWED INTEREST
          </div>
          <div className="sl-mutual-name">
            {mutualProfile.name} , {mutualProfile.age}
          </div>
          <div className="sl-mutual-meta">
            {mutualProfile.location} &bull; {mutualProfile.profession} &ndash;{" "}
            <span className="sl-match-tag">{mutualProfile.compatibilityScore}% Match</span>
          </div>
          <button className="sl-dont-miss">Don't miss this connection</button>
        </div>
        <button
          className="sl-start-convo-btn"
          onClick={onStartConvo}
        >
          <svg
            width="15"
            height="15"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
          >
            <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" />
          </svg>
          Start Conversation
        </button>
      </div>
    </>
  );
}

/* ─────────────────────────────────────────
   PROFILE CARD
───────────────────────────────────────── */
function ProfileCard({
  profile,
  index,
  isSent,
  onSendInterest,
  onRemove,
  showRemove = true,
  navigate
}) {
  return (
    <div className="sl-card" style={{ animationDelay: `${index * 0.08}s` }}>
      <div className="sl-card-photo">
        {profile.img ? (
          <img 
          src={profile.img} 
          alt={profile.name} 
          onError={(e) => {
            e.target.src = userAvatar; // Fallback to default avatar
          }}
          />
        ) : (
          <div className="sl-photo-placeholder">
            <svg viewBox="0 0 24 24" fill="currentColor">
              <path d="M12 12c2.7 0 4.8-2.1 4.8-4.8S14.7 2.4 12 2.4 7.2 4.5 7.2 7.2 9.3 12 12 12zm0 2.4c-3.2 0-9.6 1.6-9.6 4.8v2.4h19.2v-2.4c0-3.2-6.4-4.8-9.6-4.8z" />
            </svg>
          </div>
        )}
      </div>

      <div className="sl-card-body">
        <div className="sl-card-name-row">
          <span className="sl-card-name">{profile.name}</span>
          {profile.verified && (
            <span className="sl-verified-badge">
              <svg
                width="10"
                height="10"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2.5"
              >
                <polyline points="20 6 9 17 4 12" />
              </svg>
              Verified
            </span>
          )}
        </div>

        <div className="sl-card-meta">
          <span>{profile.age} yrs</span>
          <span className="sl-card-meta-dot">&bull;</span>
          <svg
            width="11"
            height="11"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
          >
            <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z" />
            <circle cx="12" cy="10" r="3" />
          </svg>
          <span>{profile.location}</span>
        </div>

        <div className="sl-card-edu">
          <svg
            width="12"
            height="12"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
          >
            <path d="M22 10v6M2 10l10-5 10 5-10 5z" />
            <path d="M6 12v5c3 3 9 3 12 0v-5" />
          </svg>
          <span>
            {profile.education} &middot; {profile.profession}
          </span>
        </div>

        <div className="sl-card-bio">{profile.bio}</div>

        <div className="sl-compat-row">
          <span className="sl-compat-label">Compatibility score</span>
          <span className="sl-match-pill">{profile.compatibilityScore}% Match</span>
        </div>
        <div className="sl-progress-track">
          <div
            className="sl-progress-fill"
            style={{ width: `${profile.compatibilityScore}%` }}
          />
        </div>
      </div>

      <div className="sl-card-actions">
        <button
          className={`sl-btn-interest${isSent ? " sent" : ""}`}
          onClick={onSendInterest}
        >
          {profile?.interestStatus === "accepted" ? " Interest Accepted" : profile?.interestStatus === "rejected" ? " Interest Rejected" : profile?.interestStatus === "pending" ? " Interest Sent" : ' Send Interest'}
          {/* {isSent ? "✓ Interest Sent" : "Send Interest"} */}
        </button>
        <button className="sl-btn-view" onClick={()=>navigate('/profile/' + profile.profileId)}>View</button>
        {showRemove && (
          <button className="sl-btn-delete" onClick={onRemove} title="Remove">
            <svg
              width="14"
              height="14"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
            >
              <polyline points="3 6 5 6 21 6" />
              <path d="M19 6l-1 14H6L5 6" />
              <path d="M10 11v6M14 11v6" />
              <path d="M9 6V4h6v2" />
            </svg>
          </button>
        )}
      </div>
    </div>
  );
}

/* ─────────────────────────────────────────
   MAIN EXPORT
───────────────────────────────────────── */
export default function Shortlisted() {
  const {t} = useTranslation();
  const [activeTab, setActiveTab] = useState("shortlistedYou");
  const [removedIds, setRemovedIds] = useState([]);
  const [sentIds, setSentIds] = useState([]);
const [shortlistsMineData, setShortlistsMineData] = useState([]);
const [shortlistsYouData, setShortlistsYouData] = useState([]);
 const [toast, setToast] = useState(null);
  const [chatOpen, setChatOpen] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const  {shortlistsMine, shortlistsReceived}  = useSelector((state) => state.shortList);

 useEffect(() => {
  const id = localStorage.getItem("profileId");

  if (id) {
    dispatch(fetchUserShortlistsMine());
    dispatch(fetchUserShortlistsReceived());
  }
}, [dispatch]);

useEffect(() => {
  const shortListMineData = [];
  const shortlistsYouData = [];
  let profileURL = userAvatar; // Replace with actual profile image URL if available
if (shortlistsMine?.data?.length > 0) {
  shortlistsMine?.data?.forEach((s) => {
    profileURL = s?.profilePhoto?.url ? process.env.REACT_APP_UPLOAD_IMAGE_URL +'/'+ s.profilePhoto.url : userAvatar;
    const profile = {
      id: s.shortlistId,
      name: s.name,
      age: s.age,
      location: s.location,
      education: s.education,
      profession: s.profession,
      bio: s.bio,
      compatibilityScore: s.compatibilityScore,
      mutualInterest: s.mutualInterest,
      img: profileURL,
      profileId: s.profileId,
      shortlistId: s.shortlistId,
      interestStatus: s.interestStatus
    };
    shortListMineData.push(profile);
  });
}
setShortlistsMineData(shortListMineData);

if(shortlistsReceived?.data?.length > 0) {
  shortlistsReceived.data.forEach((s) => {
    profileURL = s?.profilePhoto?.url ? process.env.REACT_APP_UPLOAD_IMAGE_URL + "/" + s.profilePhoto.url : userAvatar;
    const profile = {
      id: s.shortlistId,
      name: s.name,
      age: s.age,
      location: s.location,
      education: s.education,
      profession: s.profession,
      bio: s.bio,
      compatibilityScore: s.compatibilityScore,
      mutualInterest: s.mutualInterest,
      img: profileURL,
      profileId: s.profileId,
      shortlistId: s.shortlistId,
      interestStatus: s.interestStatus
    };
    shortlistsYouData.push(profile);
  });
}
setShortlistsYouData(shortlistsYouData);

}, [shortlistsMine, shortlistsReceived]);

  const handleRemove = (profileId) => {
    // setRemovedIds((prev) => [...prev, id]);
    if(profileId) {
      dispatch(userAddShortlistProfile(profileId)).unwrap().then((res) => {
          showToast(res?.message || "Profile removed from shortlist!", "success");
        setRemovedIds((prev) => [...prev, profileId]);
        dispatch(fetchUserShortlistsMine());
        dispatch(fetchUserShortlistsReceived());
      }).catch((err) => {
        console.log('Error removing from shortlist:', err);
      });
    }
  };
  const handleSendInterest = (profileId) => {
    // setSentIds((prev) =>
    //   prev.includes(profileId) ? prev.filter((id) => id !== profileId) : [...prev, profileId]
    // );
    if(profileId) {
      dispatch(sendInterestToProfile(profileId)).unwrap().then((res) => {
        console.log('shorlistres:',res);
         showToast(res?.message || "Profile shortlisted!", "success");
        setSentIds((prev) =>
          prev.includes(profileId) ? prev.filter((id) => id !== profileId) : [...prev, profileId]
        );
        dispatch(fetchUserShortlistsMine());
        dispatch(fetchUserShortlistsReceived());
      }).catch((err) => {
        console.log('Error sending interest:', err);
      });
    }
}

  const visibleProfiles = shortlistsMineData.filter((p) => !removedIds.includes(p.id));
console.log('shortlistsYouData:',shortlistsYouData);

const showToast = (msg, type = "success") => {
    setToast({ msg, type });
    setTimeout(() => setToast(null), 3000);
  };

  return (
    <div className="sl-page">
      <div className="sl-header">
        <h1>{t("shortlist_title")}</h1>
        <p>{t("shortlist_sub")}</p>
      </div>

      <div className="sl-tabs-wrapper">
        <div className="sl-tabs">
          <button
            className={`sl-tab-btn ${activeTab === "youShortlisted" ? "active" : ""}`}
            onClick={() => setActiveTab("youShortlisted")}
          >
            <svg
              className="sl-tab-icon"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
            >
              <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z" />
            </svg>
            <span>{t("shortlist_tab_you")} <br /> {t("shortlist_tab_you1")}</span>
          </button>

          <button
            className={`sl-tab-btn ${activeTab === "shortlistedYou" ? "active" : ""}`}
            onClick={() => setActiveTab("shortlistedYou")}
          >
            <svg
              className="sl-tab-icon"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
            >
              <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" />
              <circle cx="9" cy="7" r="4" />
              <path d="M23 21v-2a4 4 0 0 0-3-3.87" />
              <path d="M16 3.13a4 4 0 0 1 0 7.75" />
            </svg>
            <span>{t("shortlist_tab_them")} <br /> {t("shortlist_tab_them1")}</span>
          </button>
        </div>
      </div>

      <div className="sl-container">
        {activeTab === "youShortlisted" && (
          <div className="sl-tab-panel" key="youShortlisted">
            {/* <MutualBanner onStartConvo={() => setChatOpen(true)} /> */}
            <div className="sl-grid">
              {shortlistsMineData.map((p, i) => (
                <ProfileCard
                  key={p.id}
                  profile={p}
                  index={i}
                  isSent={sentIds.includes(p.id)}
                  onSendInterest={() => handleSendInterest(p.profileId)}
                  onRemove={() => handleRemove(p?.shortlistId)}
                  showRemove={true}
                  navigate={navigate}
                />
              ))}
            </div>
            {visibleProfiles.length === 0 && (
              <div className="sl-empty">
                <div className="sl-empty-icon">💌</div>
                <h3>{t("shortlist_empty_title")}</h3>
                <p>{t("shortlist_empty_sub")}</p>
              </div>
            )}
          </div>
        )}

        {activeTab === "shortlistedYou" && (
          <div className="sl-tab-panel" key="shortlistedYou">
            {/* <MutualBanner onStartConvo={() => setChatOpen(true)} /> */}
            <div className="sl-you-grid">
              {shortlistsYouData.map((p, i) => (
                <ProfileCard
                  key={p.id}
                  profile={p}
                  index={i}
                  isSent={sentIds.includes(p.id)}
                  onSendInterest={() => handleSendInterest(p.profileId)}
                  onRemove={() => handleRemove(p.profileId)}
                  showRemove={false}
                  navigate={navigate}
                />
              ))}
            </div>
              {shortlistsYouData.length === 0 && (
                <div className="sl-empty">
                  <div className="sl-empty-icon">💌</div>
                  <h3>{t("shortlist_empty_title")}</h3>
                  <p>{t("shortlist_empty_sub")}</p>
                </div>
              )}
          </div>
        )}
      </div>

      {/* Chat Box */}
      <ChatBox
        isOpen={chatOpen}
        onClose={() => setChatOpen(false)}
        profile={mutualProfile}
      />
       {toast &&
       <div className={`toast ${toast.type}`}>{toast.msg}</div>
      }
    </div>
  );
}